// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wc","content":"xc","crumbsList":"yc","dropdownsWrap":"zc"};